import React from 'react';

import styles from './Text.module.scss';

type TextProps = {
  tag?: 'div' | 'p' | 'span' | 'strong';
  children: React.ReactNode;
  className?: string;
  variants?: 'primary' | 'secondary' | 'tertiary' | 'fixed' | 'verify';
  size?:
    | 'display1'
    | 'display2'
    | 'display3'
    | 'display4'
    | 'display5'
    | 'display6'
    | 'xxs'
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg';
};

const Text: React.FC<TextProps> = ({
  tag = 'span',
  children,
  className = '',
  variants,
  size = 'md',
}) => {
  const Tag = tag as keyof JSX.IntrinsicElements;

  const sizeClass = styles[size] || '';

  return (
    <Tag className={`${styles.text} ${sizeClass} ${className} ${variants ? styles[variants] : ''}`}>
      {typeof children === 'string' ? (
        <span dangerouslySetInnerHTML={{ __html: children }} />
      ) : (
        children
      )}
    </Tag>
  );
};

export default Text;
